import Vue from 'vue';
import Router from 'vue-router';

import { loginRoutes } from '@/app/features/login/login.routes';
import { homeRoutes } from '@/app/features/home-pages/home.routes';
import { timeSheetsRoutes } from '@/app/features/time-sheets/time-sheets.routes';
import { expensesRoutes } from '@/app/features/expenses/expenses.routes';
import { assignmentsRoutes } from '@/app/features/assignments/assignments.routes';
import { permPlacementsRoutes } from '@/app/features/perm-placements/perm-placements.routes';
import { contractorsRoutes } from '@/app/features/contractors/contractors.routes';
import { tesEmployeesRoutes } from '@/app/features/tes-employees/tes-employees.routes';
import { notificationsRoutes } from '@/app/features/notifications/notifications.routes';
import { preferencesRoutes } from '@/app/features/preferences/preferences.routes';
import { profileRoutes } from '@/app/features/profile/profile.routes';
import { adminRoutes } from '@/app/features/admin/admin.routes';
import { helpRoutes } from '@/app/features/help/help.routes';
import { dashboardRoutes } from '@/app/features/dashboard/dashboard.routes';
import { authGuard } from './guards/auth.guard';
import { clearGlobals } from './guards/clear-globals.guard';
import { clientsRoutes } from '@/app/features/clients/clients.routes';
import { clientContactsRoutes } from '@/app/features/client-contacts/client-contacts.routes';
import { suppliersRoutes } from '@/app/features/suppliers/suppliers.routes';
import { supplierContactsRoutes } from '@/app/features/supplier-contacts/supplier-contacts.routes';
import { recentItemsRoutes } from '@/app/features/recent-items/recent-items.routes';
import { usersRoutes } from '@/app/features/users/users.routes';
import { purchaseOrdersRoutes } from './app/features/purchase-orders/purchase-orders.routes';
import { advancedSearchRoutes } from '@/app/features/advanced-search/advanced-search.routes';
import { depositSlipsRoutes } from '@/app/features/deposit-slips/deposit-slips.routes';
import { payrollOverviewsRoutes } from '@/app/features/payroll-overviews/payroll-overviews.routes';
import { projectsRoutes } from '@/app/features/projects/projects.routes';
import { reportRoutes } from './app/features/report/reports.routes';
import { placementActivityRoutes } from './app/features/placement-activity/placement-activity.routes';
import { notFoundRoutes } from './app/features/not-found/not-found.routes';
import { unavailableRoutes } from './app/features/unavailable/unavailable.routes';
import { aodaRoutes } from './app/features/aoda/aoda.routes';

Vue.use(Router);

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    ...unavailableRoutes,
    ...notFoundRoutes,
    ...homeRoutes,
    ...loginRoutes,
    ...timeSheetsRoutes,
    ...expensesRoutes,
    ...assignmentsRoutes,
    ...permPlacementsRoutes,
    ...purchaseOrdersRoutes,
    ...contractorsRoutes,
    ...tesEmployeesRoutes,
    ...adminRoutes,
    ...helpRoutes,
    ...notificationsRoutes,
    ...preferencesRoutes,
    ...profileRoutes,
    ...dashboardRoutes,
    ...clientsRoutes,
    ...clientContactsRoutes,
    ...suppliersRoutes,
    ...supplierContactsRoutes,
    ...recentItemsRoutes,
    ...usersRoutes,
    ...advancedSearchRoutes,
    ...depositSlipsRoutes,
    ...payrollOverviewsRoutes,
    ...projectsRoutes,
    ...reportRoutes,
    ...placementActivityRoutes,
    ...aodaRoutes
  ]
});

router.beforeEach(clearGlobals);
router.beforeEach(authGuard); // authentication will be checked for all routes with meta requiresAuth: true
export default router;
